module.exports = __webpack_public_path__ + "static/media/checkBlueWhite.5591fd91.svg";